/* PagingWorkTrigFeed.js */

const PagingFeed = require("../../../../lib/PagingFeed");

class PagingWorkTrigFeed extends PagingFeed {
    constructor(...args) {
        super(...args);
        this._filter = {
            $userQuery: {},
            $systemQuery: {status: {$ne: "DELETING"}},
        };
    }
    _getFeed() {
        return this._EntityDef.startTriggerTypesFeed(
            this._userSession.activeOrganization.id,
            this._updateFilterWithDefault(this._filter),
            this._fields,
            this._sort,
            {skip: 0, limit: this._pageSize * 2}
        );
    }

    _getFeedIdsForSelection(tenantId, selection) {
        return this._EntityDef.loadTriggerTypeIdsForSelection(tenantId, selection);
    }

    getTriggerTypeEntitiesById(ids) {
        return this.getEntitiesByIdAsProm(ids);
    }

    getTriggerTypeEntitiesNameById(ids) {
        // "displayName", not "name": getName() aliases getDisplayName(), so projecting "name"
        // fetches a field the getter never reads. Uncached rows came back undefined and both
        // DeleteAction and RunAction then called .length on it.
        return this.getEntitiesValueByIdAsProm(ids, "displayName");
    }

    getTriggerTypeEntityById(id) {
        return this.getEntityById(id);
    }

    setFilter(filterQuery, silent) {
        super.setFilter(this._updateFilterWithDefault(filterQuery), silent);
    }

    _updateFilterWithDefault(filterQuery) {
        let _filter;
        if (filterQuery && Object.keys(filterQuery).length > 0) {
            _filter = {
                $and: [filterQuery, {triggerType: "SCHEDULE"}],
            };
        } else {
            _filter = {
                triggerType: "SCHEDULE",
            };
        }
        return _filter;
    }
}

module.exports = PagingWorkTrigFeed;
